<template>
  <div class="pc_main-info">
    <div>
      <!-- <div class="price-main">
        <div>
          <div class="subsidy-title">{{ $t('PCModelInfo.index.647h1f4yr6c0') }}</div>
          <div class="money-div">
            <span class="dun">{{ moneyData.currencySymbol }}</span>
            {{ moneyData.evaluation }}
          </div>
        </div>
        <div class="subsidy-div" v-if="moneyData.bonus && moneyData.bonus > 0">
          <div class="subsidy-title">{{ $t('PCModelInfo.index.647h1f4yso80') }}</div>
          <div class="money-div">
            <span class="dun">{{ moneyData.currencySymbol }}</span>
            {{ moneyData.bonus }}
          </div>
        </div>

        <div class="subsidy-div" v-if="moneyData.expertDiscount && moneyData.expertDiscount > 0">
          <div class="subsidy-title">推广码补贴</div>
          <div class="money-div">
            <span class="dun">{{ moneyData.currencySymbol }}</span>
            {{ moneyData.expertDiscount }}
          </div>
        </div>
      </div> -->

      <ul class="tips">
        <li>{{$t('PCModelInfo.index.64tve23zt0g0')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zup00')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zuy40')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zv7g0')}}</li>
      </ul>

      <h5 class="title">{{$t('PCModelInfo.index.64tve23zvbg0')}}</h5>
      <p class="p-text">{{$t('PCModelInfo.index.64tve23zvf80')}}</p>

      <ul class="tips">
        <li>{{$t('PCModelInfo.index.64tve23zvjc0')}}</li>
        <li>{{$t('PCModelInfo.index.64tve23zvms0')}}</li>
      </ul>

      <h5 class="title">{{$t('PCModelInfo.index.64tve23zvqg0')}}</h5>
      <ul class="contact-info">
        <li class="p-text2" v-html="$t('PCModelInfo.index.64tve23zvyo0')">
        </li>
        <li class="p-text2" v-html="$t('PCModelInfo.index.64tve23zwak0')">  </li>
      </ul>

      <h5 class="title">{{$t('PCModelInfo.index.64tve23zwgs0')}}</h5>
      <ul class="contact-info">
        <li class="p-text2">{{$t('PCModelInfo.index.64tve23zwm80')}}</li>
        <li class="p-text2" v-html="$t('PCModelInfo.index.64tve23zwt00')"></li>
        <li class="p-text2">{{$t('PCModelInfo.index.64tve23z9d6f')}}</li> 
      </ul>

      <div class="plaint-text">
        <img src="@/assets/image/eu-home/plaint.png" alt="" />
        {{$t('PCModelInfo.index.64tve23zwwk0')}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PCMainInfo',
  props: {
    dataList: Array,
    moneyData: Object
  },
  data() {
    return {
      lang: ''
    };
  },
  mounted() {
    this.$nextTick(() => {});
    this.lang = sessionStorage.getItem('lang') || 'es';
  },
  methods: {},
  created() {}
};
</script>

<style scoped lang="less">
.pc_main-info {
  width: 880px;
  border-radius: 8px;
  // height: 650px;
  padding: 24px;
  background-color: #fff;
  font-size: 16px;
  color: #282828;
  overflow: hidden;
  box-sizing: border-box;
  // padding: 40px;
  .medium-div {
    font-weight: 600;
    margin: 16px 12px;
    display: flex;
    align-items: center;
    color: #333;
    font-family: PoetsenOne;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-shadow: 0 0 10px rgba(224, 37, 255, 0.6); /* 设置文本的模糊效果 */
    img {
      // width: 16px;
      height: 22px;
      margin-right: 5px;
    }
  }
  .price-main {
    display: flex;
    height: 55px;
    margin-top: 16px;
    margin-left: 16px;
    margin-bottom: 24px;
    .money-div {
      font-weight: 600;
      font-size: 40px;
      line-height: 56px;
    }
    .subsidy-title {
      color: #6e6e6e;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
    }
    .subsidy-div {
      margin-left: 47px;
      position: relative;
      color: #ff7b24;
    }
    .subsidy-div:after {
      position: absolute;
      top: 29px;
      left: -31px;
      content: '+';
      width: 15px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      font-size: 24px;
      color: #999;
    }
    .dun {
      font-size: 28px;
    }
  }

  .title {
    color: var(--text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 32px 0 8px 10px;
  }

  .p-text {
    color: var(--text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 12px;
    margin-left: 10px;
  }

  .p-text2 {
    list-style-type: disc;
    margin-bottom: 8px;
    line-height: 1.5;
  }

  .contact-info {
    margin-top: 16px;
    margin-left: 30px;
  }

  .plaint-text {
    img{
      width: 28px;
      height: 28px;
      margin-right: 12px;
    }
    display: flex;
    border-radius: 8px;
    align-items: center;
    background-color: #FBFBFB;
    color: var(--text-3, #8f949d);
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 16px;
    margin-top: 16px;
  }

  .tips {
    background: #f8f8f8;
    padding: 16px 40px;
    border-radius: 8px;
    li {
      list-style-type: disc;
      color: var(--text-3, #8f949d);
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 6px;
    }
    li:last-child{
      margin-bottom: 0;
    }
  }

  .notice {
    color: var(--text-2, #5d5f65);
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 12px;
    margin-bottom: 32px;
    margin-left: 10px;
    span {
      display: block;
      margin-bottom: 8px;
    }
  }

  /deep/ .el-input__count {
    height: 56px;
  }
  .error-input {
    /deep/.el-input__inner {
      border-color: #ee0a24;
      color: #ee0a24;
    }
  }
  .error-input-text {
    margin-top: 12px;
    color: #ee0a24;
    font-size: 14px;
  }
}
</style>
